import { post } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

const realTimePricingUrl = "/api/v1/realtimepricing";

export function customGetProductCollectionRealTimePrices(parameter: GetProductCollectionRealTimePriceApiV2Parameter) {
    let url = realTimePricingUrl;

    if (parameter.additionalQueryStringParameters) {
        const queryStringParameters = new URLSearchParams();
        for (const key of Object.keys(parameter.additionalQueryStringParameters)) {
            const value = parameter.additionalQueryStringParameters[key];
            if (value !== undefined) {
                queryStringParameters.append(key, value);
            }
        }

        const queryString = queryStringParameters.toString();
        if (queryString) {
            url += `?${queryString}`;
        }
    }

    return post<GetProductCollectionRealTimePriceApiV2Parameter, RealTimePricingModel>(url, {
        productPriceParameters: parameter.productPriceParameters,
    });
}